
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuKintanKintanImage } from "@src/constants/images";
import { meta as noodleStandTokyoPageMeta } from "./noodle_stand_tokyo.mdx";
export const meta = {
  path: "/media/harajuku/kintan",
  title: "【肉寿司も!?】焼肉の人気店kintanで絶品ランチを堪能しよう！",
  description: "原宿で焼肉ランチなら、焼肉の名店kintanの絶品ランチ一択。ランチ以外にもオススメの肉寿司を写真付きで、人気店だからこその気になる行列情報も予約ができるかどうかも併せてご紹介！原宿でkintanにお越しの際には、ぜひこちらの記事をご確認ください。",
  topImg: harajukuKintanKintanImage,
  author: murakamiMasanori,
  tags: ["焼肉", "有名店", "おしゃれな内装", "ガッツリ", "人気店", "お店の紹介", "こってり", "メニュー詳細", "食べログ高評価"]
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const ShopInfoBox = makeShortcode("ShopInfoBox");
const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿で焼肉ランチなら、焼肉の名店 kintan の絶品ランチは絶対に外さないメニューが盛り沢山。デート、会食、友人とのランチなど幅広いシーンで利用できるのが特徴。`}</p>
    <p>{`ランチはもちろんのこと、オススメの肉寿司を写真付きで、人気店だからこその気になる行列情報を、予約ができるかどうかも併せてご紹介！`}</p>
    <p>{`原宿で kintan にお越しの際には、ぜひこちらの記事をご確認して行ってみてください。`}</p>
    <h2>{`kintan`}</h2>
    <p>{`kintan は都内に 18 店舗を構える高級焼肉のお店で、焼肉以外にもしゃぶしゃぶ、肉割烹なども店舗展開しています。
食べログの評価は 3.5 を超える実力派のお店で、ランチをはじめとしていろんなシーンで使用されております。`}</p>
    <h3>{`薄暗いムードある雰囲気`}</h3>
    <InstaImage postId="BvZdHo8B_am" mdxType="InstaImage" />
    <p>{`原宿 kintan はお店の外から薄暗くムードのある雰囲気で、証明も明るすぎないオレンジ色の照明を使用しています。いろんなシーンで使いやすい店内の雰囲気は、少し非日常な感じでオススメのお店。`}</p>
    <hr></hr>
    <h2>{`ランチメニュー`}</h2>
    <p>{`kintan の原宿店では驚くほど多くのランチメニューが提供されています。
全てのランチのセットに、五穀米、スープ、野菜がついているので、ボリューム感はあるのにバランスの取れたメニューが堪能できます。`}</p>
    <h3>{`kintan スペシャルセット`}</h3>
    <InstaImage postId="B6LcSKLAMgd" mdxType="InstaImage" />
    <p>{`5 種類の厳選されたお肉が食べられるランチメニューになっています。
牛タンやハラミなど、脂の乗ったお肉を心ゆくまで堪能できます。他のランチと比べて少し値段は高めですが、特別なランチタイムでは奮発してでも食べたい一品。`}</p>
    <h3>{`牛タン焼肉セット`}</h3>
    <InstaImage postId="Bwwd3xsArt2" mdxType="InstaImage" />
    <p>{`厚みのある木皿に牛タンが一枚一枚丁寧に並べられたランチは、牛タン好きにはたまらない一品。
女性の方に特に人気のランチで、五穀米やスープと一緒に食べれば、お肉を食べているのにバランスの取れたヘルシーな一品になります。牛タンを特製のソースで召し上がってみてください。`}</p>
    <h3>{`30 日間熟成牛タン食べ比べセット`}</h3>
    <InstaImage postId="Bv6hB5PAflX" mdxType="InstaImage" />
    <p>{`牛タン焼肉セットをさらにグレードアップさせたのがこちらのランチ。熟成させた牛タンは発色が明るく、食べた瞬間に芳醇な香りが口の中を駆け巡る。`}</p>
    <h3>{`こんなメニューが`}</h3>
    <h4>{`肉寿司`}</h4>
    <InstaImage postId="BybhBs3AAk9" mdxType="InstaImage" />
    <p>{`高級なトリュフや雲丹がふんだんに使用されていて、肉好きには頼まずにはいられない一品。ランチメニューを安く抑えて、友達とシェアをして食べるのがおすすめです！`}</p>
    <hr></hr>
    <h2>{`行列情報`}</h2>
    <p>{`原宿の kintan は行列になることが少ないので、行列に並ぶ心配をせずに、安心してお越しいただくことができます。
少し原宿のランチの価格帯と比較して値段が高めなので、並びすぎるのような心配はありません。
必要であれば、ランチでも予約ができるようになっているので、心配な方はあらかじめ予約しておくのがいいと思います。`}</p>
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`原宿の人気焼肉店 kintan についてご紹介しましたが、いかがでしたか。
想像するよりもコスパがよくバランスの取れたランチメニューから、行列が意外とできず予約ができるなど、表に出てこないような情報がご紹介できたのではないかと思います。
原宿で焼肉ランチの際には、kintan で素敵な時間をお過ごしください。`}</p>
    <ShopInfoBox shopId="brruvmq23akg00835qag" mdxType="ShopInfoBox" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;